<div class="pointCF__field">
  <label
    ppTooltip
    class="pointCF__label"
    ppTitle="{{ ppCustomField?.label }}"
    [ppTrimTooltip]="true"
  >
    <img class="pointCF__bulk-changes-field-icon" [src]="EIconPath.CUSTOM_FIELD_TEXT_ACTIVITY" />

    <span class="pointCF__label-container">
      {{ ppCustomField?.label }}
    </span>
  </label>

  <div
    class="pointCF__content"
    ppTooltip
    [ppTitle]="ppCustomField.lockedValue ? ('locked_by_admin' | ppTranslate) : ''"
  >
    <textarea
      [disabled]="disabled"
      [attr.disabled]="disabled ? true : null"
      [attr.readonly]="disabled ? true : null"
      rows="1"
      ppTooltip
      [ppTitle]="disabled ? '' : ppCustomFields[ppCustomField.id]"
      [ppTrimTooltip]="true"
      autocomplete="off"
      class="customFieldText__input pointCF__input input custom-list-input"
      [class.customFieldText__input--locked]="disabled"
      type="text"
      name="customtext{{ ppCustomField?.label }}"
      [(ngModel)]="ppCustomFields[ppCustomField.id]"
      [placeholder]="!disabled ? ('enter_text' | ppTranslate) : '--'"
      (input)="onInput($event)"
      (keydown.enter)="blurInput($event)"
      (change)="updateText(ppCustomField)"
      #input
      (keydown)="onKeyDown($event, ppCustomField.id)"
    ></textarea>

    @if (ppCustomField.lockedValue) {
      <div class="pointCF__padlock">
        <pp-padlock-icon />
      </div>
    } @else {
      <button class="pointCF__clear" (click)="clearCustomField(ppCustomField.id)">&#xd7;</button>
    }
  </div>
</div>
